export const SUSIMDAL_CLASS_ACADEMY_IDS = [
    "669a6bcd76ff7f70d2e6631b",
    "671083645970133849c27b6a",
] as const;

export const isSusimdalClassAcademy = (academyId: string): boolean => {
    return SUSIMDAL_CLASS_ACADEMY_IDS.includes(
        academyId as (typeof SUSIMDAL_CLASS_ACADEMY_IDS)[number],
    );
};
